import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'page-virtual-departments',
  props: ['widgetStyle', 'widgetConfig'],
  data() {
    return {
      selectedDepartmentId: null,
    };
  },
  computed: {
    ...mapGetters(['departments']),
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
        borderColor: this.widgetStyle.main_color,
      };
    },
  },
  methods: {
    ...mapActions(['toggleWidgetModal', 'makeCallToDepartment', 'sendOrderCallDisposition', 'resetStatus', 'makeCallToDepartment']),
    cancel() {
      this.resetStatus();
      this.toggleWidgetModal();
    },
    orderCall() {
      if (this.selectedDepartmentId) {
        this.makeCallToDepartment(this.selectedDepartmentId);
      }
    },
  },
};
